module.exports = __webpack_public_path__ + "img/section2Logo4.553eaf72.png";